export default "__VITE_ASSET__92d7877e__"